var map = {
	"./American Express.png": "ee88",
	"./Boleto Bancário.png": "1125",
	"./Elo.png": "cc39",
	"./Hipercard.png": "7909",
	"./Mastercard.png": "6af0",
	"./Null.png": "6129",
	"./Pix.png": "cbcc",
	"./Visa.png": "94a5",
	"./pay (10).png": "755c",
	"./pay (12).png": "dead",
	"./pay (3).png": "980f",
	"./pay (6).png": "5efe",
	"./pay (7).png": "b971",
	"./pay (8).png": "396c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0606";